import { useCallback, useEffect, useMemo, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate } from 'react-router-dom';
import { createUserService } from "../../../../features/users/service/users-service";
import { fetchRolesWithoutAdmin } from "../../../../shared/services/roles";
import userData from "../../../../features/users/forms/user-data";
import storage from "../../../../shared/services/storage";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import { fetchCompaniesService as getCompanies } from "../../../../features/company/service/company";
import InfoComponent from "../../../../components/info/info";
import { SecretariaProjectAccessController } from "../../../../features/users/logic/secretaria-project-access-controller";

export function AddUser() {
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();
    const [rolesOptions, setRolesOptions] = useState<any[]>([]);
    const [isMaster, setIsMaster] = useState(false);
    const projectAccessController = useMemo(() => new SecretariaProjectAccessController(), []);

    const handleCreateUser = async (formData: any) => {
        if(!formData) {
            showAlert('Dados inválidos', SEVERITY.ERROR);
            return;
        }

        const user = JSON.parse(storage.getStorage('user') || '');
        
        if(formData) {
            try {
                const payload = { ...formData, firstAcess: true };

                if(!isMaster && !!user?.name && user?.name.toLowerCase() !== 'cauane') {
                    payload.companyId = user?.company.id;
                }

                if (isMaster) {
                    projectAccessController.ensureCompanyForMaster(isMaster, payload.companyId);
                }

                const selectedProjectIds = Array.isArray(payload.projectIds) ? payload.projectIds : [];
                projectAccessController.ensureProjectSelection(payload.roleId, rolesOptions, selectedProjectIds);

                if (projectAccessController.isSecretariaRole(payload.roleId, rolesOptions)) {
                    payload.projectIds = selectedProjectIds;
                } else {
                    delete payload.projectIds;
                }

                const response = await createUserService(payload);

                if(response) {
                    showAlert('Usuário criado com sucesso', SEVERITY.SUCCESS);
                    navigate('/usuarios');
                } 

                if(!response) {
                    showAlert('Erro ao criar usuário', SEVERITY.ERROR);
                }
            } catch (error: any) {
                showAlert(error.message || 'Erro ao criar usuário', SEVERITY.ERROR);
            }
        }
    };

    const fetchRolesData = useCallback(async () => {
        try {
            const roles = await fetchRolesWithoutAdmin();
            const companies = await getCompanies();
            const user = JSON.parse(storage.getStorage('user') || '');
            const nextRolesOptions = roles?.map(({ name, id}: any) => ({ label: name, value: id })) || [];
            const nextIsMaster = user?.name.toLowerCase() === 'cauane';
            const secretariaRoleId = nextRolesOptions.find((role: any) => role.label?.toLowerCase() === 'secretaria')?.value;

            setRolesOptions(nextRolesOptions);
            setIsMaster(nextIsMaster);

            const projectOptions = nextIsMaster
                ? []
                : await projectAccessController.loadProjectOptions(user?.company?.id);

            const data = userData(
                undefined,
                undefined,
                nextRolesOptions,
                nextIsMaster,
                companies,
                projectOptions,
                secretariaRoleId,
                (companyId?: string) => projectAccessController.loadProjectOptions(companyId)
            );
            setFormData(data);
        } catch (error) {
            console.log(error);
        }
    }, [projectAccessController]);


    useEffect(() => {
        fetchRolesData();
    }, [fetchRolesData]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Usuários', 'Adicionar usuário']} href={['/usuarios', '']} />
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleCreateUser}
                            onCancel={() => navigate('/usuarios')}
                            title="Adicionar usuário"
                        />
                    </>
                )}
            </div>
        </div>
    );
}
